export const starterDocument = {
  type: "doc",
  content: [
    {
      type: "heading",
      attrs: { level: 1 },
      content: [{ type: "text", text: "Your Title" }],
    },
    {
      type: "paragraph",
      content: [
        {
          type: "text",
          text: "Welcome! This is a sample document to help you get started.",
        },
      ],
    },
    {
      type: "paragraph",
      content: [
        {
          type: "text",
          text: "Example: ",
          marks: [{ type: "bold" }],
        },
        {
          type: "text",
          text: "This is an example of bold text.",
        },
      ],
    },
    {
      type: "paragraph",
      content: [
        {
          type: "text",
          text: "You can also ",
        },
        {
          type: "text",
          text: "italicize",
          marks: [{ type: "italic" }],
        },
        {
          type: "text",
          text: " or ",
        },
        {
          type: "text",
          text: "highlight",
          marks: [{ type: "highlight" }],
        },
        {
          type: "text",
          text: " important text.",
        },
      ],
    },
    {
      type: "paragraph",
      content: [
        {
          type: "text",
          text: "Code example: ",
        },
        {
          type: "text",
          text: "`console.log('Hello World')`",
          marks: [{ type: "code" }],
        },
      ],
    },
    {
      type: "bulletList",
      content: [
        {
          type: "listItem",
          content: [{ type: "paragraph", content: [{ type: "text", text: "Organize your thoughts" }] }],
        },
        {
          type: "listItem",
          content: [{ type: "paragraph", content: [{ type: "text", text: "Make checklists" }] }],
        },
        {
          type: "listItem",
          content: [{ type: "paragraph", content: [{ type: "text", text: "Stay productive" }] }],
        },
      ],
    },
  ],
};
